if (process.env.NODE_ENV === "development") {
  // Mocking the environment configuration for development
  let config = {
    success: true,
    data: {
      bffBaseEndpoint: "https://dev-bff.nymus.eu",
      keycloakUrl: "https://dev-idp.nymus.eu/auth",
      keycloakRealm: "nymus-admin",
      keycloakClient: "nymus-admin-ui",
    },
  };
  window.environment = config;
  window._env_.VUE_APP_BFF_URL = config.data.bffBaseEndpoint;

  // Set axios default header to be added to all requests
  // axios.defaults.headers.common['x-suppliergroup-override'] = 'dev-test.nymus.eu';

  require("./app");
} else {
  fetch(window._env_.VUE_APP_BFF_URL + "/environment")
    .then((res) => res.json())
    .then((config) => {
      window.environment = config;
      require("./app");
    });
}
